<template>
  <section id="dash-profit" class="flex column">
    <!-- filters -->
    <div class="flex-1 w100 margin-top-l">
      <div class="flex row middle">
        <div class="flex-1 w100">
          <div class="flex end filters-group-holder row">
            <div class="flex-1 w100">
              <div class="flex flex-1  middle">
                <div class="button primary" @click="openModalCreate()">
                  Criar Funil
                </div>
                <div class="flex column" style="margin-left: 16px">
                  Quantidade de funils: {{ account.used_limits.limit_funnel | number }} / {{ account.plan_limits.limit_funnel | number }}
                  <div class="margin-top-s">Precisa de mais funils? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
                </div>
              </div>
            </div>
            <div style="margin-right: 16px;" class="flex column no-mobile">
              <label>Atualizar dados</label>
              <div class="flex end w100" style="margin-top:12px">
                <div @click="forceRefreshData()" class="button secondary">
                  <i class="fas fa-sync-alt"></i>
                </div>
              </div>
            </div>

            <div style="margin-right: 16px;" class="flex column no-mobile">
              <label>TV</label>
              <div class="flex end w100" style="margin-top:12px">
                <div
                  @click="fullScreenDash('dash-profit')"
                  class="button secondary"
                >
                  <i class="fas fa-tv"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(fun, key) in funnils" :key="key" class="flex-1 w100 margin-top-l">
      <funnel-detail :funnel_id="fun.id" :key="`${fun.id}-${countRefresh}`" @delete="openToDelete($event)"></funnel-detail>
    </div>

    <div v-if="isEmpty" class="box flex w100 margin-top-l">
      <div class="box-content">
        <p>
          Não encontramos nenhum funil criado. Crie seu primeiro funil visualizar.
        </p>
      </div>
    </div>
      <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      @close="closeToEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newFunnel.name"
                autocomplete="off"
              />
            </div>

          
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrUpdateFunnel()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Link?"
      @cancel="
        showModalDelete = false;
        selectedFunnelId = null;
      "
      @accept="deleteFunnel(selectedFunnelId.id)"
    ></modal-confirm>
  </section>
</template>

<script>
import {
  getFunnels,
  createFunnel,
  deleteFunnel,
} from "@/services/funnel";

import FunnelDetail from "@/modules/funnel/FunnelDetail";

const EMPTY_FUNNEL = {
  name: "",
};

import moment from "moment";
moment.locale("pt-br");

import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

export default {
  name: "dash-lead",
  components: {
    FunnelDetail,
    Modal,
    ModalConfirm
  },
  data() {
    return {
      loading: false,
      isTvMode: false,
      refreshTime: 60, // 60s refresh data
      refreshInterval: null,
      countRefresh: 0,
      totalfunnels: 0,
      funnils: [],
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedFunnelId: null,
      newFunnel: Object.assign({}, EMPTY_FUNNEL),
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          currency: "BRL",
          sumCostsFixed: true,
          sourceLead: 'MARKETING',
          accountAds: '',

        },
        list: {
          listAccountAds: [],
        },
      },
    };
  },
  mounted() {
    this.getReport();

    // this.refreshInterval = setInterval(this.getReport, this.refreshTime * 1000);
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      return this.isEdit ? 'Editar Funil': 'Criar Funil'
    },
    isEdit() {
      if (this.newFunnel && this.newFunnel.id) {
        return true
      }
      return false
    },
    isEmpty() {
      return this.totalfunnels === 0 && !this.loading;
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_funnel <= this.account.used_limits.limit_funnel) {
        return true
      }

      return false
    },
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.getReport();
      },
    },
  },
  methods: {
    forceRefreshData() {
      this.getReport();
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de funis do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    openToDelete(sl) {
      this.showModalDelete = true;
      this.selectedFunnelId = sl;
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false;
      this.newFunnel = Object.assign({}, EMPTY_FUNNEL);
    },
    saveOrUpdateFunnel() {
      if (this.isEdit) {
        this.updateFunnel(this.newFunnel.id);
      } else {
        this.createFunnel();
      }
      this.closeToEdit();
    },
    fullScreenDash(elementId) {
      var elem = document.getElementById(elementId);

      // disable fullscreen
      if (this.isTvMode) {
        this.isTvMode = false;
        document.exitFullscreen();
        document.body.style.zoom = 1;

        return;
      }

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }

      document.body.style.zoom = 0.8;

      this.isTvMode = true;
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    getReport() {
      if (this.loading) {
        return;
      }

      this.countRefresh += 1

      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: 1,
        offset: 500,
      };

      getFunnels(params)
        .then((result) => {
          this.funnils = result.funnels;
          this.totalfunnels = result.total;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createFunnel() {
      let params = {
        name: this.newFunnel.name,
      };
      createFunnel(params)
        .then((result) => {
          this.funnils.push(result);
          this.totalfunnels = this.totalfunnels + 1

          this.$toast.success({
            title: "Sucesso",
            message: "Link criado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteFunnel(funnelId) {
      deleteFunnel(funnelId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Link deletado com sucesso",
          });

          this.funnils = this.funnils.filter(e => e.id != funnelId)
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedFunnelId = null;
          this.showModalDelete = false
        })
    },
  },
};
</script>

<style lang="scss" scoped>
#dash-profit {
  background: var(--bg);
}

.filters-group-holder {
  position: sticky;
  top: -1px;
  z-index: 4;

  &[stuck] {
    background: var(--bg);
    padding: 35px 5px 15px 5px;
  }
}

.custom-card {
  min-width: 250px;
  position: relative;
  .big-icon {
    i {
      color: var(--primary);
      font-size: 28px;
    }
  }
  .title {
    white-space: nowrap;
  }
  .info {
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: 16px;
  }
  h3 {
    font-size: 22px;
    white-space: nowrap;
  }
  h1 {
    font-size: 32px;
    color: var(--primary);
  }

  &.negative {
    h1 {
      color: #fff !important;
    }
  }
}
.primary-bg {
  background: var(--primary);

  h1 {
    color: #fff;
  }

  span {
    color: #fff;
  }
}

.primary-bg {
  .source-data{
    h3 {
      // color: var(--terciary);
      color: #fff;
      font-weight: 400;
    }
  }
}

.source-data {
  h3 {
    color: var(--text2);
    font-weight: 400;
  }
}

li {
  list-style-type: none;
  padding-bottom: 8px;
  padding-top: 8px;
  border-bottom: 1px solid #e6e4e4;
  padding-left: 8px;
  
}

.red {
    color: red;
  }
.gren {
    color: green;
}

.max-table {
  overflow-y: scroll;
  max-height: 400px;
  padding-bottom: 16px;
}

</style>
